import { SectionKey } from "types/planning";

export interface StepDef {
  key: string;
  label: string;
}

export interface SectionDef {
  key: SectionKey;
  label: string;
  /** Tailwind class for step cell color when colored */
  cellColor: string;
  /** Tailwind class for section header row background */
  headerBg: string;
  /** Tailwind class for section header text */
  headerText: string;
  steps: StepDef[];
  /** Step keys used as reference for charge artisan (first colored week only) */
  charge_step_keys: string[];
}

export const PLANNING_SECTIONS: SectionDef[] = [
  {
    key: "gros_oeuvre",
    label: "GROS ŒUVRE",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "fondation_soubassement", label: "Fondation, Soubassement" },
      { key: "dallage", label: "Dallage" },
      { key: "elevation", label: "Élévation" },
      { key: "dressement", label: "Dressement, appuis surbots et seuils" },
      { key: "reseaux_exterieurs", label: "Réseaux extérieurs, réglage terre" },
    ],
    charge_step_keys: ["dallage", "elevation"],
  },
  {
    key: "assainissement",
    label: "ASSAINISSEMENT",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "reseaux_assainissement", label: "Réseaux assainissement" },
    ],
    charge_step_keys: ["reseaux_assainissement"],
  },
  {
    key: "charpente",
    label: "CHARPENTE",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "appor_gabarit", label: "Appor gabarit maçon" },
      { key: "pose_charpente", label: "Pose charpente" },
    ],
    charge_step_keys: ["pose_charpente"],
  },
  {
    key: "couverture",
    label: "COUVERTURE",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "pose_couverture", label: "Pose couverture" },
      { key: "goutieres_descentes", label: "Gouttières, descentes EP" },
    ],
    charge_step_keys: ["pose_couverture"],
  },
  {
    key: "etancheite",
    label: "ÉTANCHÉITÉ",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "pose_etancheite", label: "Pose étanchéité" },
    ],
    charge_step_keys: ["pose_etancheite"],
  },
  {
    key: "menuiserie",
    label: "MENUISERIE EXT. INT.",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "pose_menuiserie_ext", label: "Pose menuiserie ext." },
      { key: "appros_huisserie", label: "Appros huisserie int." },
      { key: "finition_menuiseries", label: "Finition menuiseries int. et ext." },
    ],
    charge_step_keys: ["pose_menuiserie_ext", "finition_menuiseries"],
  },
  {
    key: "escalier",
    label: "ESCALIER",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "pose_escalier", label: "Pose escalier" },
    ],
    charge_step_keys: ["pose_escalier"],
  },
  {
    key: "enduit",
    label: "ENDUIT EXTÉRIEUR",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "enduit", label: "Enduit" },
    ],
    charge_step_keys: ["enduit"],
  },
  {
    key: "ravalement",
    label: "RAVALEMENT",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "ravalement", label: "Ravalement" },
    ],
    charge_step_keys: ["ravalement"],
  },
  {
    key: "chape",
    label: "CHAPE",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "pose_chape", label: "Pose chape" },
      { key: "sechage_chape", label: "Séchage chape" },
    ],
    charge_step_keys: ["pose_chape"],
  },
  {
    key: "isolation",
    label: "ISOLATION",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "isolation_combles", label: "Isolation combles" },
    ],
    charge_step_keys: ["isolation_combles"],
  },
  {
    key: "cloisonnement",
    label: "CLOISONNEMENT",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "plafonds_doublages", label: "Plafonds et doublages" },
      { key: "cloisonnement", label: "Cloisonnement" },
      { key: "bandes", label: "Bandes" },
    ],
    charge_step_keys: ["plafonds_doublages"],
  },
  {
    key: "carrelage",
    label: "CARRELAGE FAÏENCE",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "chapes", label: "Chapes" },
      { key: "sechage_chape", label: "Séchage chape" },
      { key: "pose_carrelages", label: "Pose carrelages" },
      { key: "faience", label: "Faïence" },
    ],
    charge_step_keys: ["chapes", "pose_carrelages"],
  },
  {
    key: "electricite",
    label: "ELECTRICITE",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "incorporation_reseaux_dallage_terre", label: "Incorporation réseaux dallage-terre" },
      { key: "filerie_avant_cloisons", label: "Filerie avant cloisons et plafonds" },
      { key: "filerie_cloisons", label: "Filerie cloisons" },
      { key: "appareillage_tableaux_vmc", label: "Appareillage, tableaux, VMC" },
    ],
    charge_step_keys: ["filerie_avant_cloisons"],
  },
  {
    key: "plomberie",
    label: "PLOMBERIE SANIT.",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "incorporation_reseaux_dallage", label: "Incorporation réseaux dallage" },
      { key: "incorporations_cloisons_doublages", label: "Incorporations dans cloisons et doublages" },
      { key: "collecteurs", label: "Collecteurs" },
      { key: "isolation_sol", label: "Isolation au sol" },
      { key: "preparation_attentes", label: "Préparation attentes et tuyauteries sol" },
      { key: "pose_appareils_sanitaires", label: "Pose appareils sanitaire, mise en eau" },
    ],
    charge_step_keys: ["incorporation_reseaux_dallage", "isolation_sol"],
  },
  {
    key: "photovoltaique",
    label: "PHOTOVOLTAÏQUE",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "installation_pv", label: "Installation photovoltaïque" },
    ],
    charge_step_keys: ["installation_pv"],
  },
  {
    key: "cuisine",
    label: "CUISINE",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "pose_cuisine", label: "Pose cuisine" },
    ],
    charge_step_keys: ["pose_cuisine"],
  },
  {
    key: "peinture",
    label: "PEINTURE",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "sous_couche", label: "Sous couche" },
      { key: "couche_finition", label: "Couche de finition" },
    ],
    charge_step_keys: ["sous_couche", "couche_finition"],
  },
  {
    key: "parquet",
    label: "PARQUET",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "pose_parquet", label: "Pose du parquet" },
    ],
    charge_step_keys: [],
  },
  {
    key: "controle_re2020",
    label: "CONTRÔLE RE2020",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "controle_re2020_1", label: "Contrôle RE2020 (1)" },
      { key: "controle_re2020_2", label: "Contrôle RE2020 (2)" },
    ],
    charge_step_keys: [],
  },
  {
    key: "livraison",
    label: "DÉLAI DE LIVRAISON",
    cellColor: "bg-neutral-800",
    headerBg: "bg-neutral-200",
    headerText: "text-neutral-700",
    steps: [
      { key: "mise_en_service", label: "Mise en service" },
      { key: "reception", label: "Réception" },
    ],
    charge_step_keys: [],
  },
];

/** Mapping from section_key → reference step keys for charge artisan calculation */
export const CHARGE_ARTISAN_REFERENCE_STEPS: Record<string, string[]> = Object.fromEntries(
  PLANNING_SECTIONS.map((s) => [s.key, s.charge_step_keys])
);

/** Section keys that appear in charge artisan (those with at least one reference step) */
export const CHARGE_ARTISAN_SECTION_KEYS = PLANNING_SECTIONS
  .filter((s) => s.charge_step_keys.length > 0)
  .map((s) => ({ key: s.key, label: s.label }));

/** Get section definition by key */
export function getSectionDef(key: string): SectionDef | undefined {
  return PLANNING_SECTIONS.find((s) => s.key === key);
}

/** Number of weeks for each model */
export const MODEL_WEEK_COUNTS: Record<string, number> = {
  "11_mois": 48,
  "12_mois": 52,
  "12_mois_ordre": 52,
  "13_mois_avec_conges": 56,
  "14_mois_avec_conges": 60,
  "15_mois_avec_conges": 64,
};
